import AddUser from "./add-user.component";

export default AddUser;
